import {prepareHeapAnalytics} from '../../../src/shared/helpers/tracking/heap';

export function BootstrapUnauthenticatedManagerRun(
    UnauthenticatedAccountSettingsApi,
    $q,
    MobileBannerService,
    GlobalizeLoaderService,
    Locale,
    $window,
    RecaptchaSettingsService,
    PublicFeatureFlagsService,
    UnauthenticatedAppcuesService
) {
    $q.all({
        accountSettings: UnauthenticatedAccountSettingsApi.getUnauthenticatedAccountSettings(),
        authServerService: PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.AuthServerForManagerApiService),
    }).then((results) => {
        if (!results || !results.accountSettings) {
            return;
        }

        const settings = results.accountSettings;
        if ($window.location.pathname.toLowerCase() === '/manager/public/authentication/login'
            && settings.ReCaptchaSettings
            && !results.authServerService) {
            RecaptchaSettingsService.setReCaptchaScript(settings.ReCaptchaSettings);
        }

        GlobalizeLoaderService.loadGlobalizeScript(settings.SubscriberSettingsInfo.Culture);
        Locale.set(settings.SubscriberSettingsInfo.Culture);

        if (settings.AvailableServicesInfo && settings.AvailableServicesInfo.IsAppcuesAvailable) {
            UnauthenticatedAppcuesService.initialize();
        }

        if (settings.AnalyticsSettingsInfo && settings.SubscriberSettingsInfo) {
            const analyticsAccount = {
                AccountId: settings.SubscriberSettingsInfo.AccountId
            };
            prepareHeapAnalytics(analyticsAccount, settings.AnalyticsSettingsInfo);
        }

        if (settings.SubscriberSettingsInfo) {
            window.sessionStorage.setItem('global_signin_url', settings.SubscriberSettingsInfo.GlobalSignInUrl);
        }
    });

    MobileBannerService.setMobileBanner(null);
}

BootstrapUnauthenticatedManagerRun.$inject = [
    'UnauthenticatedAccountSettingsApi',
    '$q',
    'MobileBannerService',
    'GlobalizeLoaderService',
    'Locale',
    '$window',
    'RecaptchaSettingsService',
    'PublicFeatureFlagsService',
    'UnauthenticatedAppcuesService'
];
